import { DatabaseLineageUpstreamDataQualityWarningsQuery_databases_upstreamDataQualityWarningsConnection_nodes } from '../../../gen-src/queries/DatabaseLineageUpstreamDataQualityWarningsQuery';
import { FlowLineageUpstreamDataQualityWarningsQuery_flows_upstreamDataQualityWarningsConnection_nodes } from '../../../gen-src/queries/FlowLineageUpstreamDataQualityWarningsQuery';
import { PublishedDatasourceLineageUpstreamDataQualityWarningsQuery_publishedDatasources_upstreamDataQualityWarningsConnection_nodes } from '../../../gen-src/queries/PublishedDatasourceLineageUpstreamDataQualityWarningsQuery';
import { TableLineageUpstreamDataQualityWarningsQuery_databaseTables_upstreamDataQualityWarningsConnection_nodes } from '../../../gen-src/queries/TableLineageUpstreamDataQualityWarningsQuery';

type Warning =
  DatabaseLineageUpstreamDataQualityWarningsQuery_databases_upstreamDataQualityWarningsConnection_nodes |
  TableLineageUpstreamDataQualityWarningsQuery_databaseTables_upstreamDataQualityWarningsConnection_nodes |
  FlowLineageUpstreamDataQualityWarningsQuery_flows_upstreamDataQualityWarningsConnection_nodes |
  PublishedDatasourceLineageUpstreamDataQualityWarningsQuery_publishedDatasources_upstreamDataQualityWarningsConnection_nodes;

type Warnings = ReadonlyArray<Warning>;

export const emptyWarnings: Warnings = [];

export function filterOutWarningsFromAnchorUntilCycleIsFixed(nodeId: string, upstream: Warnings): Warnings {
  return upstream?.filter(w => w.asset?.id !== nodeId);
}
